import type { SlotContribution } from '@/shared/registry'
import { savedSearchesSlot } from '@/shared/search/search-screen-context'

/** Open and Save on every search screen's toolbar (SM-27), in GW-20's saved-search slot. */
export const savedSearchSlots: readonly SlotContribution[] = [
  {
    kind: 'action',
    slot: savedSearchesSlot,
    id: 'saved-searches',
    component: () => import('./SavedSearchesAction').then((module) => module.SavedSearchesAction),
  },
]
